<template>
    <div>
        <van-skeleton title :row="3" style="margin-top: 1rem;"/>
    </div>
</template>
<script>
import { Dialog } from 'vant'
import dd from 'dingtalk-jsapi'
import { getUrlCode, getUrlCodeNew } from '@/utils/urlFormat'

export default {
    data () {
        return {
            // 提示文字
            loadingText: '',
            // 登录表单
            loginForm: {
                userName: this.$route.query.userName,
                type: this.$route.query.type
            },
            // 跳转页面
            redirect: undefined,
            // 默认登录异常提示信息
            defaultErrMsg: '您暂无权限，请联系管理员'
        }
    },
    watch: {
        $route: {
            handler: function (route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true
        }
    },
    created () {
        let ticket = getUrlCode('ticket')
        if (ticket !== undefined && ticket !== '' && ticket !== null) {
            let callbackUrl = getUrlCode('callbackUrl')
            let query = {
                user: '',
                ticket: ticket,
                type: ''
            }
            // callbackUrl为1说明是从绩效面板点击业绩看板图标进入，解决返回问题
            if (callbackUrl && callbackUrl !== '1') {
                let param = atob(unescape(encodeURIComponent(decodeURIComponent(callbackUrl))))
                let user = getUrlCodeNew('user', param)
                let type = getUrlCodeNew('type', param)
                query.user = user
                query.type = type
            }
            this.handleLoginCA(query)
        } else {
            this.handleLogin()
        }
    },
    mounted () {
        // 判断是否是在钉钉里运行
        if (dd.env.platform !== 'notInDingTalk') {
            dd.config({
                agentId: '', // 必填，微应用ID
                corpId: '', // 必填，企业ID
                timeStamp: '', // 必填，生成签名的时间戳
                nonceStr: '', // 必填，自定义固定字符串。
                signature: '', // 必填，签名
                type: 0, // 选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
                jsApiList: [
                    'biz.navigation.setLeft',
                    'biz.navigation.close'
                ] // 必填，需要使用的jsapi列表，注意：不要带dd。
            })
            dd.ready(function () {
                const u = navigator.userAgent
                // const that = this
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                if (isiOS) {
                    // IOS返回
                    dd.biz.navigation.setLeft({
                        control: true,
                        onSuccess: function () {
                            // if (that.$route.path === '/index') {
                            //     dd.biz.navigation.close()
                            // } else {
                            //     window.history.back()
                            // }
                        }
                    })
                } else {
                    // Android返回
                    document.addEventListener('backbutton', function () {
                        // if (that.$route.path === '/index') {
                        //     dd.biz.navigation.close()
                        // }
                    })
                }
            })
        } else {
            // 普通浏览器返回（钉钉开发者工具上测试过可以监听到钉钉的返回）
            window.addEventListener('popstate', function () {
                // 处理回退键事件

            })
        }
    },
    methods: {
        // 普通登录
        handleLogin () {
            if (this.loginForm.userName) {
                this.$store.dispatch('Login', this.loginForm).then((res) => {
                    // this.$router.replace({path: this.redirect || '/', query: {token: res.data.userId}})
                     this.$router.replace({path: this.redirect || '/', query: {tm: new Date().getTime()}})
                }).catch(() => {
                    Dialog.alert({
                        title: '提示',
                        message: this.defaultErrMsg,
                        confirmButtonColor: '#008AFF'
                    }).then(() => {
                        // on close
                    })
                })
            } else {
                Dialog.alert({
                    title: '提示',
                    message: this.defaultErrMsg,
                    confirmButtonColor: '#008AFF'
                }).then(() => {
                    // on close
                })
            }
        },
        // 统一认证平台跳转过来的登录
        handleLoginCA (query) {
            this.$store.dispatch('LoginCA', query).then((res) => {
                // this.$router.replace({path: this.redirect || '/', query: {token: res.data.userId}})
                this.$router.replace({path: this.redirect || '/', query: {tm: new Date().getTime()}})
            }).catch(() => {
                Dialog.alert({
                    title: '提示',
                    message: this.defaultErrMsg,
                    confirmButtonColor: '#008AFF'
                }).then(() => {
                    // on close
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/index.vue